import { IconsTypesProps } from '../../types';

export const WaterTowerScadaIcon = ({ width = 47, height = 103 }: IconsTypesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 47 103"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 11.4444C0 5.12384 5.12385 0 11.4444 0H35.0963C41.4169 0 46.5407 5.12385 46.5407 11.4444V30.5185C46.5407 36.8391 41.4169 41.963 35.0963 41.963H26.8309C26.1286 41.963 25.5593 42.5323 25.5593 43.2346V102.746C25.5593 102.886 25.4454 103 25.3049 103H20.4728C20.3324 103 20.2185 102.886 20.2185 102.746V43.2346C20.2185 42.5323 19.6492 41.963 18.9469 41.963H11.4445C5.12386 41.963 0 36.8391 0 30.5185V11.4444Z"
      fill="white"
    />
    <path
      d="M11.4443 0.126953H35.0967C41.3468 0.127157 46.414 5.19415 46.4141 11.4443V30.5186C46.414 36.7688 41.3469 41.8357 35.0967 41.8359H26.8311C26.0586 41.8359 25.4317 42.4619 25.4316 43.2344V102.746C25.4314 102.816 25.3748 102.873 25.3047 102.873H20.4727C20.4027 102.873 20.3459 102.816 20.3457 102.746V43.2344C20.3456 42.4621 19.7196 41.8361 18.9473 41.8359H11.4443C5.19404 41.8359 0.126974 36.7689 0.126953 30.5186V11.4443C0.127006 5.19405 5.19405 0.127012 11.4443 0.126953Z"
      stroke="#566369"
      strokeOpacity="0.32"
      strokeWidth="0.254321"
    />
    <path
      d="M2.28906 12.9703C2.28906 6.64974 7.41292 1.52588 13.7335 1.52588H32.8076C39.1282 1.52588 44.252 6.64973 44.252 12.9703V29.0061C44.252 35.3267 39.1282 40.4506 32.8076 40.4506H24.1861V101.22C24.1861 101.36 24.0722 101.474 23.9318 101.474H21.915C21.7746 101.474 21.6607 101.36 21.6607 101.22V40.4506H13.7335C7.41291 40.4506 2.28906 35.3267 2.28906 29.0061V12.9703Z"
      fill="#F4F4F7"
    />
    <path
      d="M13.7335 40.4505H20.3891C21.0914 40.4505 21.6607 41.0198 21.6607 41.7221V101.22C21.6607 101.36 21.7746 101.474 21.915 101.474H23.9318C24.0722 101.474 24.1861 101.36 24.1861 101.22V41.7221C24.1861 41.0198 24.7554 40.4505 25.4577 40.4505H32.8076C39.1282 40.4505 44.252 35.3267 44.252 29.0061V22.2598H2.28906V29.0061C2.28906 35.3267 7.41291 40.4505 13.7335 40.4505Z"
      fill="#2486FD"
      fillOpacity="0.2"
    />
    <line
      y1="-0.12716"
      x2="62.8917"
      y2="-0.12716"
      transform="matrix(-0.0849196 0.996388 -0.997701 -0.0677706 5.34082 40.1831)"
      stroke="#566369"
      strokeOpacity="0.32"
      strokeWidth="0.254321"
    />
    <line
      y1="-0.12716"
      x2="62.8917"
      y2="-0.12716"
      transform="matrix(0.0849196 0.996388 0.997701 -0.0677706 41.2002 40.1831)"
      stroke="#566369"
      strokeOpacity="0.32"
      strokeWidth="0.254321"
    />
    <path
      d="M5.37747 40.2387L42.2163 53.9163"
      stroke="#566369"
      strokeOpacity="0.32"
      strokeWidth="0.178025"
    />
    <path
      d="M42.217 53.916L3.08889 68.3265"
      stroke="#566369"
      strokeOpacity="0.32"
      strokeWidth="0.178025"
    />
    <path
      d="M3.17882 68.2852L44.633 83.7988"
      stroke="#566369"
      strokeOpacity="0.32"
      strokeWidth="0.178025"
    />
    <path
      d="M0.253906 101.856L44.7601 83.7992"
      stroke="#566369"
      strokeOpacity="0.32"
      strokeWidth="0.178025"
    />
    <path
      d="M17.8224 19.672V16.5722H17.084V16.0999C17.3206 16.0999 17.5114 16.078 17.6564 16.0341C17.8034 15.9883 17.9131 15.9234 17.9856 15.8395C18.0581 15.7536 18.101 15.6515 18.1144 15.5332H18.6697V19.672H17.8224Z"
      fill="#3B3B3B"
    />
    <path
      d="M20.271 19.672V16.5722H19.5325V16.0999C19.7691 16.0999 19.9599 16.078 20.105 16.0341C20.2519 15.9883 20.3616 15.9234 20.4341 15.8395C20.5066 15.7536 20.5496 15.6515 20.5629 15.5332H21.1182V19.672H20.271Z"
      fill="#3B3B3B"
    />
    <path
      d="M25.1118 16.7124V17.2935H24.4879V19.672H23.6521V17.2935H23.1054V16.7124H23.6521V16.286C23.6521 16.0474 23.7217 15.8624 23.861 15.7307C24.0022 15.599 24.2016 15.5332 24.4592 15.5332H25.1376L25.1404 16.0885H24.7512C24.6443 16.0885 24.5709 16.1152 24.5308 16.1686C24.4926 16.2201 24.4735 16.306 24.4735 16.4262V16.7124H25.1118Z"
      fill="#3B3B3B"
    />
    <path
      d="M27.4401 17.2935H26.7818L26.7875 18.8705C26.7875 18.9431 26.7961 18.9974 26.8133 19.0337C26.8324 19.068 26.861 19.0909 26.8991 19.1024C26.9392 19.1119 26.9898 19.1167 27.0508 19.1167H27.4487V19.6319C27.4105 19.6491 27.3504 19.6653 27.2684 19.6806C27.1882 19.6958 27.0756 19.7034 26.9306 19.7034C26.6711 19.7034 26.4698 19.6701 26.3267 19.6033C26.1855 19.5365 26.0872 19.443 26.0319 19.3228C25.9766 19.2026 25.9489 19.0633 25.9489 18.9049V17.2935H25.468V16.7124H25.9775L26.1864 15.8194H26.7818V16.7096H27.4401V17.2935Z"
      fill="#3B3B3B"
    />
    <path d="M2.06543 22.1479L43.9614 22.148" stroke="#2486FD" strokeWidth="0.572443" />
  </svg>
);
